// Indicator thresholds — single source of truth.
export const RSI_OVERBOUGHT = 70;
export const RSI_OVERSOLD = 30;
export const VOLUME_SURGE_THRESHOLD = 1.5; // 1.5x 20-day average
